"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyCodeRequestSchema = exports.OtpChallengeResponseSchema = exports.SubmitEmailRequestSchema = exports.EmailSchema = void 0;
exports.normaliseEmail = normaliseEmail;
const zod_1 = require("zod");
function normaliseEmail(email) {
    return email.trim().toLowerCase();
}
// normaliseEmail is the single source of truth for trimming and lower-casing.
exports.EmailSchema = zod_1.z.string().transform(normaliseEmail).pipe(zod_1.z.email().max(254));
exports.SubmitEmailRequestSchema = zod_1.z.object({
    email: exports.EmailSchema,
    termsAccepted: zod_1.z.boolean(),
    termsVersion: zod_1.z.string().min(1).max(64),
});
exports.OtpChallengeResponseSchema = zod_1.z.object({
    /** ISO timestamp after which the code stops working. */
    expiresAt: zod_1.z.iso.datetime(),
    /** ISO timestamp from which /onboarding/resend is allowed. */
    resendAvailableAt: zod_1.z.iso.datetime(),
    emailMasked: zod_1.z.string(),
});
exports.VerifyCodeRequestSchema = zod_1.z.object({
    code: zod_1.z.string().regex(/^\d{6}$/),
});
//# sourceMappingURL=onboarding.js.map